/**
 * Caesar Cipher implementation
 * Shifts each letter by a specified number of positions in the alphabet
 */

export const caesarEncrypt = (text, shift = 3) => {
  return text.replace(/[a-zA-Z]/g, (char) => {
    const start = char >= 'A' && char <= 'Z' ? 65 : 97;
    const code = char.charCodeAt(0);
    let shifted = ((code - start + shift) % 26 + 26) % 26;
    return String.fromCharCode(shifted + start);
  });
};

export const caesarDecrypt = (text, shift = 3) => {
  return caesarEncrypt(text, -shift);
};

export const caesarCipher = {
  name: 'Caesar Cipher',
  encrypt: caesarEncrypt,
  decrypt: caesarDecrypt,
  requiresKey: true,
  keyLabel: 'Shift Value',
  keyType: 'number',
  defaultKey: 3,
  description: 'Shifts each letter by a specified number of positions'
};
